import { render, staticRenderFns } from "./role-select.vue?vue&type=template&id=0509d456&scoped=true"
import script from "./role-select.ts?vue&type=script&lang=js&external"
export * from "./role-select.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0509d456",
  null
  
)

export default component.exports